import { useState } from "react";
import VariationImage from "./VariationImage";
import VariationParametersSection from "./VariationParametersSection";
import VariationHotspotsSection from "./hotspots/VariationHotspotsSection";
import Button from "../../components/Button";
import styles from "./variationBlock.module.css";
import { ConfirmationModalControlled } from "../../components/Modal";

const VariationBlock = ({
  variation = {},
  defaultVariationId,
  hotspots = [],
  onHotspotDrag,
  onDuplicateHotspotCoords,
  getPrice,
  manualPrice,
  onDefaultToggle,
  onPriceToggle,
  disableChange,
  onPriceChange,
  onImageDelete = () => {},
  wizardParameters = [],
  wizardSelections = {},
  onWizardSelectionChange = () => {},
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const handleClose = () => {
    setModalIsOpen(false);
  };
  const handleSubmit = () => {
    onImageDelete();
    setModalIsOpen(false);
  };
  const handleCancel = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      {" "}
      <div className={styles.variationBlock}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingBottom: "var(--gap)",
          }}
        >
          <VariationImage
            img={variation.img}
            hotspots={hotspots}
            onHotspotDrag={onHotspotDrag}
            large
          />
          <div style={{ display: "flex", flexGrow: "1" }} />
          <div style={{ display: "flex", gap: "var(--gap-sm)" }}>
            <Button disabled={disableChange}>Įkelti paveikslėlį</Button>
            {variation?.img ? (
              <Button
                disabled={disableChange}
                icon={"trashIcon"}
                onClick={() => {
                  setModalIsOpen(true);
                }}
              />
            ) : null}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "var(--gap)",
            width: "100%",
          }}
        >
          <VariationParametersSection
            variation={variation}
            parameters={variation?.parameters}
            defaultVariationId={defaultVariationId}
            getPrice={getPrice}
            manualPrice={manualPrice}
            onDefaultToggle={onDefaultToggle}
            onPriceToggle={onPriceToggle}
            onPriceChange={onPriceChange}
            wizardParameters={wizardParameters}
            wizardSelections={wizardSelections}
            onWizardSelectionChange={onWizardSelectionChange}
          />
          {variation?.img != null && hotspots?.length > 0 ? (
            <VariationHotspotsSection
              hotspots={hotspots}
              handleHotspotChange={onHotspotDrag}
              onDuplicateHotspotCoords={onDuplicateHotspotCoords}
            />
          ) : null}
        </div>
      </div>
      <ConfirmationModalControlled
        isOpen={modalIsOpen}
        onClose={handleClose}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        submitLabel={"Ištrinti"}
        cancelLabel={"Atšaukti"}
      >
        <h2>{`Ar tikrai norite ištrinti paveikslėlį?`}</h2>
      </ConfirmationModalControlled>
    </>
  );
};

export default VariationBlock;
